import * as S from '../../../styles/core-styles/Dashboard-styles';

export default function ContactCta() {
  return (
    <S.CtaButton href="mailto:support@sawatchlabs.com?subject=SAWATCH%20DASHBOARD%20-%20Contact%20Support" target="_blank" rel="noopener noreferrer">
        <S.CtaIcon>?</S.CtaIcon>
        <S.CtaText>Contact Support</S.CtaText>
    </S.CtaButton>
  )
}